export const FETCHING_TECHNICIAN_GROUPS = '@@toyota/FETCHING_TECHNICIAN_GROUPS';
export const FETCHED_TECHNICIAN_GROUPS = '@@toyota/FETCHED_TECHNICIAN_GROUPS';
export const FETCHED_TECHNICIAN_GROUPS_FAILED =
  '@@toyota/FETCHED_TECHNICIAN_GROUPS_FAILED';
export const FETCHING_TECHNICIAN_GROUP_INFO = '@@toyota/FETCHING_TECHNICIAN_GROUP_INFO';
export const FETCHED_TECHNICIAN_GROUP_INFO = '@@toyota/FETCHED_TECHNICIAN_GROUP_INFO';
export const FETCHED_TECHNICIAN_GROUP_INFO_FAILED = '@@toyota/FETCHED_TECHNICIAN_GROUP_INFO_FAILED';
export const ADDING_TECHNICIAN_GROUP = '@@toyota/ADDING_TECHNICIAN_GROUP';
export const ADDED_TECHNICIAN_GROUP = '@@toyota/ADDED_TECHNICIAN_GROUP';
export const ADDED_TECHNICIAN_GROUP_FAILED = '@@toyota/ADDED_TECHNICIAN_GROUP_FAILED';
export const UPDATING_TECHNICIAN_GROUP = '@@toyota/UPDATING_TECHNICIAN_GROUP';
export const UPDATED_TECHNICIAN_GROUP = '@@toyota/UPDATED_TECHNICIAN_GROUP';
export const UPDATED_TECHNICIAN_GROUP_FAILED = '@@toyota/UPDATED_TECHNICIAN_GROUP_FAILED';
export const CLEAR_TECHNICIAN_GROUP = '@@toyota/CLEAR_TECHNICIAN_GROUP';

export const FETCHING_TECHNICIAN = '@@toyota/FETCHING_TECHNICIAN';
export const FETCHED_TECHNICIAN = '@@toyota/FETCHED_TECHNICIAN';
export const FETCHED_TECHNICIAN_FAILED = '@@toyota/FETCHED_TECHNICIAN_FAILED';
export const ADDING_TECHNICIAN = '@@toyota/ADDING_TECHNICIAN';
export const ADDED_TECHNICIAN = '@@toyota/ADDED_TECHNICIAN';
export const ADDED_TECHNICIAN_FAILED = '@@toyota/ADDED_TECHNICIAN_FAILED';
export const UPDATING_TECHNICIAN = '@@toyota/UPDATING_TECHNICIAN';
export const UPDATED_TECHNICIAN = '@@toyota/UPDATED_TECHNICIAN';
export const UPDATED_TECHNICIAN_FAILED = '@@toyota/UPDATED_TECHNICIAN_FAILED';
export const CLEAR_TECHNICIANS = '@@toyota/CLEAR_TECHNICIANS';
